import React from "react";
import { Table, Tag } from "antd";

export default function PriceDetailsTable(props) {
   const columns = [
      {
         title: "quantity",
         dataIndex: "quantity",
         key: "quantity",
         align: "center",
      },
      {
         title: "price",
         dataIndex: "price",
         key: "price",
         align: "center",
         render: (text, value) => (value.quantity > 0 ? <Tag color="green">{text}</Tag> : ""),
      },
   ];

   return (
      <div>
         <Table columns={columns} size="small" dataSource={props.tableData} pagination={{ size: "small" }} />
      </div>
   );
}
